import styles from "./PageFooter.module.css";

export default function PageFooter() {
  const year = new Date().getFullYear();

  return <div className={styles["appFooter"]}>Copyright @ Wiiste - Relia -- V20, {year}</div>;
}
